jQuery(function($) {
  var slideHandler = function(event, slick, currentSlide, nextSlide) {
    if(slick.$dots && !slick.$dots.hasClass('custom-slick-dots')) {
      return;
    }
    
    var direction = (nextSlide === currentSlide + 1) || ((currentSlide === (slick.slideCount - 1)) && nextSlide === 0) ? 'r' : 'l';
    var className = 'custom-slick-active';
    var slide = nextSlide || 0;
    var $dots = $('li', slick.$dots).removeClass([className,'dot-head-l','dot-tail-l','dot-head-r','dot-tail-r']);
    var $curDot = $dots.eq(slide);
    if(direction === 'r') {
      $dots.eq(currentSlide).addClass('dot-tail-r');
      $dots.eq((currentSlide + slick.options.slidesToShow) % slick.slideCount).addClass('dot-head-r');
    } else {
      $dots.eq(slide).addClass('dot-head-l');
      $dots.eq((slide + slick.options.slidesToShow) % slick.slideCount).addClass('dot-tail-l');
    }
    for(var i = 0; i < slick.options.slidesToShow; i++) {
      $curDot = $curDot.add($dots.eq((slide + i) % slick.slideCount));
    }
    $curDot.addClass(className);

    if(window.jsPhotoLightbox && window.jsPhotoLightbox.visible()) {
      var $nextSlide = $(slick.$slides[slide]);
      if($nextSlide.hasClass('js-photo')) {
        window.jsPhotoLightbox.close();
        $nextSlide.trigger('click');
      }
    }
  };

  $('body').on('beforeChange init reInit', '.slick-slider', slideHandler);

  $('.js-featured-multiple').each(function() {
    var $this = $(this);
    if($('*', $this).length > 1) {
      $this.slick({
        mobileFirst: true,
        dots: true,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 6000,
        dotsClass: 'custom-slick-dots',
        customPaging: function(slider, i) {
          return $('<span class="custom-slick-dot" role="button" />').text(i + 1);
        },
        responsive: [
          {
            breakpoint: 768,
            settings: {
              dots: true
            }
          }
        ]
      });
    }
  });

  $('.js-property-gallery').each(function() {
    var $this = $(this);
    var settings = {
      mobileFirst: false,
      dots: $this.children().length > 3,
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      appendDots: '.js-property-controls',
      appendArrows: '.js-property-controls',
      dotsClass: 'custom-slick-dots',
      customPaging: function(slider, i) {
        return $('<span class="custom-slick-dot" role="button" />').text(i + 1);
      },
      responsive: [
        {
          breakpoint: 1399,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: $this.children().length > 2,
          }
        },
        {
          breakpoint: 767,
          settings: 'unslick'
        }
      ]
    };

    $this.slick(settings);

    $(window).on('resize', debounce(function() {
      if(window.innerWidth > 767 && !$this.hasClass('slick-initialized')) {
        $this.slick(settings);
      }
    }, 250));
  });

  $('.js-photo').on('click', function(e) {
    e.preventDefault();
    var src = $(this).attr('href');
    window.jsPhotoLightbox = basicLightbox.create('<img src="'+src+'" />');
    window.jsPhotoLightbox.show();
  });

  $('.js-featured-slideshow').each(function() {
    var $this = $(this);
    if($('*', $this).length > 1) {
      $this.slick({
        mobileFirst: true,
        dots: false,
        autoplay: true,
        arrows: true,
        autoplaySpeed: 6000,
        dotsClass: 'custom-slick-dots',
        customPaging: function(slider, i) {
          return $('<span class="custom-slick-dot" role="button" />').text(i + 1);
        },
        responsive: [
          {
            breakpoint: 768,
            settings: {
              dots: true
            }
          }
        ]
      });
    }
  });
});